// DS: i12.1
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioProducts: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M3.2 1c-.32 0-.6.18-.74.46L1.09 4.22A.8.8 0 0 0 1 4.6v.7a2.91 2.91 0 0 0 1.1 2.28v6.52c0 .5.4.91.9.91h10c.5 0 .9-.4.9-.9V7.56A2.88 2.88 0 0 0 15 5.29v-.7a.84.84 0 0 0-.09-.37l-1.37-2.76A.82.82 0 0 0 12.8 1zm8.9 7.19c-.76 0-1.48-.31-2.02-.85l-.02-.02-.02.02a2.87 2.87 0 0 1-4.08 0l-.02-.02-.02.02c-.54.54-1.26.84-2.02.85v5h8.2zM7.25 6.28c.22.16.48.25.75.25h.05c.75 0 1.37-.62 1.37-1.38h1.37a1.38 1.38 0 0 0 1.33 1.38h.04c.76 0 1.38-.62 1.38-1.38 0-.2-.02-.39-.1-.56l-.02-.06-1.02-1.69-.1-.18H3.65L2.61 4.69l-.02.07c-.04.12-.04.25-.04.38a1.38 1.38 0 0 0 1.33 1.39h.05c.76 0 1.37-.62 1.37-1.38h1.37c0 .46.23.87.58 1.13"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
StudioProducts.displayName = 'StudioProducts';

export default StudioProducts;
